import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

export const immersiveSaveButtonContainerId =
  'immersive-trip-header-save-button-container'

// Only these paths can be in immersive mode. Add more as needed.
const immersiveHeaderPathsWhitelist = [
  '/:region/offer/:id',
  '/:region/partner/:id',
  '/:region/tour/:id',
  '/:region/cruises/:id',
  '/:region/experience/:id',
  '/:region/flights-search-results',
  '/:region/search',
  '/:region/checkout',
  '/:region/booking',
  '/:region/account/my-escapes/order',
]

export function immersiveModeEnabledForPath(path: string) {
  return !!matchLocaleAwarePath(path, { path: immersiveHeaderPathsWhitelist })
}
